import { Component, OnInit, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoggingService } from 'src/app/core/services/logging.service';
import * as c3 from 'c3';

@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss']
})
export class DonutChartComponent implements OnInit {
  @Input() columns: any[];
  @Input() title: string;
  @Input() type: any;
  @Input() key: string;
  @Input() value: any;
  @Input() isAdminView: boolean;
  @Input() colorPatters: string[];
  public regionNameArr: string[];
  public showLegend = true;

  public bindTo = 'donutChart' + Math.floor(Math.random() * 10000);

  constructor(private loggingService: LoggingService) {
    this.columns = [
      ['Complete', 30],
      ['In Progress', 120],
      ['Not Started', 80]
    ];
    this.colorPatters = ['#28A745', '#DD5900', '#DEE2E6'];
    this.title = "Total 100";
  }

  ngOnInit(): void {
    try {
      if (this.key === 'ADMIN_CP_QP_NOMINATION') {
        this.columns = [
          ['Complete', this.value.completed],
          ['In Progress', this.value.inprogress],
          ['Not Started/Ready to Start', this.value.notStarted],
        ];
        const totalCount = this.value.completed + this.value.inprogress + this.value.notStarted;
        this.title = "Total \n" + totalCount;
      } else if (this.key === 'MANAGE_WORKFLOWS_REPORTING_WORKFLOW') {
        this.columns = [
          ['Complete', this.value.completed],
          ['In Progress', this.value.inprogress],
          ['Not Started/Ready to Start', this.value.notStarted],
        ];
        const totalCount = this.value.completed + this.value.inprogress + this.value.notStarted;
        this.title = "Total \n" + totalCount;
      } else if (this.key === 'WORKFLOW_DASHBOARD') {
        let completeItemArr = ['Complete'];
        let inProgressItemArr = ['In Progress'];
        let notStartedItemArr = ['Not Started'];
        this.regionNameArr = [];
        let totalCount = 0;
        let indexCount = 0;
        for (let item of this.value) {
          if (indexCount < 3) {
            completeItemArr.push(item.workFlowStatus.completed);
            inProgressItemArr.push(item.workFlowStatus.inprogress);
            notStartedItemArr.push(item.workFlowStatus.notStarted);
            this.regionNameArr.push(item.regionTitle);
          }
          totalCount = totalCount + Number(item.workFlowStatus.completed) + Number(item.workFlowStatus.inprogress) + Number(item.workFlowStatus.notStarted);
          this.value['completed'] = !isNaN(this.value['completed']) ? this.value['completed'] + Number(item.workFlowStatus.completed) : Number(item.workFlowStatus.completed);
          this.value['inprogress'] = !isNaN(this.value['inprogress']) ? this.value['inprogress'] + Number(item.workFlowStatus.inprogress) : Number(item.workFlowStatus.inprogress);
          this.value['notStarted'] = !isNaN(this.value['notStarted']) ? this.value['notStarted'] + Number(item.workFlowStatus.notStarted) : Number(item.workFlowStatus.notStarted);
          indexCount++;
        }
        this.columns = totalCount > 0 ? [completeItemArr, inProgressItemArr, notStartedItemArr] : [];
        this.title = "Total " + totalCount;
      } else if (this.key === 'CP_QP_Nomination') {
        this.showLegend = false;
        this.columns = [
          ['Ready to Start', this.value.readyStartCount],
          ['Data Input', this.value.dataCapture],
          ['Endorse Stage 1', this.value.endorserbyORC],
          ['Endorse Stage 2', this.value.endorserNewCPQP],
          ['Approve CP/QP', this.value.inApproval],
          ['Complete', this.value.complete],
          ['Rejected', this.value.rejected],
          ['Not Started', this.value.notStarted],
          ['Processing Failed', this.value.processingFailed]
        ];
        this.colorPatters = ['#CED4DA', '#DD5900', '#F77F00', '#FCBA5E', '#0099CC', '#28A745', '#FF2D41', '#FFFFFF', '#993399'];
        this.title = this.getTotalCalculatedVal(Number(this.value.complete), Number(this.value.totalCount));
      } else if (this.key === 'reporting_workflow') {
        this.showLegend = false;
        this.columns = [
          ['Ready to Start', this.value.readyStartCount],
          ['Data Entry', this.value.dataCapture],
          ['Review by ORC', this.value.reviewbyORC],
          ['Endorse Stage 1', this.value.endorserStage1],
          ['Endorse Stage 2', this.value.endorserStage2],
          ['Complete', this.value.complete],
          ['Rejected', this.value.rejected],
          ['Not Started', this.value.notStarted],
          ['Processing Failed', this.value.processingFailed]
        ];
        this.colorPatters = ['#CED4DA', '#DD5900', '#0099CC', '#F77F00', '#FCBA5E', '#28A745', '#FF2D41', '#FFFFFF', '#993399'];
        this.title = this.getTotalCalculatedVal(Number(this.value.complete), Number(this.value.totalCount));
      } else if (this.key === 'reporting_workflow_consent') {
        this.showLegend = false;
        this.columns = [
          ['Ready to Start', this.value.readyStartCount],
          ['Upload Documents', this.value.uploadDocuments],
          ['Upload Printer Proof', this.value.uploadPrinterProof],
          ['Acknowledgement', this.value.acknowledgement],
          ['Consent to Publish', this.value.conscentToPublish],
          ['Complete', this.value.complete],
          ['Rejected', this.value.rejected],
          ['Not Started', this.value.notStarted],
          ['Processing Failed', this.value.processingFailed]
        ];
        this.colorPatters = ['#CED4DA', '#DD5900', '#cea214', '#F77F00', '#FCBA5E', '#28A745', '#FF2D41', '#FFFFFF', '#993399'];
        this.title = this.getTotalCalculatedVal(Number(this.value.complete), Number(this.value.totalCount));
      }

      setTimeout(() => {
        let regionNameArr = this.regionNameArr;
        let type = this.type
        let chart = c3.generate({
          bindto: `#${this.bindTo}`,
          data: {
            columns: this.columns,
            type: this.type
          },
          legend: {
            show: false
          },
          donut: {
            title: this.title
          },
          color: {
            pattern: this.colorPatters
          },
          tooltip: {
            format: {
              title: function (d, i) {
                if (type === 'bar') {
                  return regionNameArr[i];
                }
              },
              value: function (value, index, d) {
                if (type !== 'bar') {
                  index = index * 100;
                  return Math.round(index) + '%';
                } else {
                  return value.toString();
                }
              }
            }
          }
        });
        if (this.key === 'WORKFLOW_DASHBOARD' && this.isAdminView) {
          chart.groups([['Complete', 'In Progress', 'Not Started']])
        }
      }, 500);
    } catch (error) {
      this.loggingService.logTrace('donut-chart.component -> ngOnInit() ', error);
    }
  }

  /**
   * @description calculate total percentage value for completed workflow
   *
   * @param {number} completeWF total completed worklfow count
   * @param {number} TotalWF total worklfow initialted count
   * @return {*}  {string} value to display in donut chart
   * @memberof DonutChartComponent
   */
  getTotalCalculatedVal(completeWF: number, TotalWF: number): string {
    let calculatTotal = '0';
    if(TotalWF > 0) {
      calculatTotal = (100 * Number(completeWF)/Number(TotalWF)).toFixed();
    }
    const donutCenterText = "Complete "+ calculatTotal + '%';
    return donutCenterText;
  }

}
